import { defaultValues } from './defaultFormValues';

export const buildLocationString = (locationData) => {
  const location = [
    locationData?.area,
    locationData?.city,
    locationData?.district,
    locationData?.street,
    locationData?.house_number,
  ]
    .filter((v) => !!v)
    .join(', ');

  if (location.length === 0) return null;

  return location;
};

export const getDefaultVaSettingsByType = (type) => {
  switch (type) {
    case 'people_count': return defaultValues.crowd;
    case 'fights_analytics': return defaultValues.fight;
    case 'weapon_analytics': return defaultValues.weapon;
    case 'fire_analytics': return defaultValues.fire;
    case 'facecover_analytics': return defaultValues.facecover;
    case 'bags_analytics': return defaultValues.bags;
    case 'lying_analytics': return defaultValues.lying;
    case 'handsup_analytics': return defaultValues.handsup;
    case 'fall_analytics': return defaultValues.fall;
    default: return {};
  }
};
